import { useEffect, useState } from 'react';

/**
 * Waits for typing to stop before letting a value through.
 *
 * <p>
 * 300ms, and the same 300ms everywhere: search hits the database, and a per-keystroke round trip on
 * a table the size of the customer master is the difference between a picker that feels instant and
 * one that fights the typist. The customers, items and units screens each carried their own copy of
 * this before the booking screen needed a fourth — three identical definitions is the point at which
 * a shared one stops being premature.
 * </p>
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
